<template>
  <div>
    <div class="mb-4 mt-10 py-3 text-lg lg:text-2xl w-full pb-10">
      <h1 class="w-11/12 mx-auto uppercase">
        {{$t('student.payments')}}
      </h1>
    </div>
    <cards-list class="font-sans-serif" />
    <!--<iban-list class="mt-16 font-sans-serif" />-->
  </div>
</template>

<script>
import CardsList from '../payment/CardsList.vue';
// import IbanList from '../payment/IbanList.vue';

export default {
  components: { CardsList },

};
</script>
